import React, { useCallback, useMemo } from "react";
import { VideoPageModal } from "@/containers/VideoPages";
import { useQueryParam } from "@/utils";

export const useSuperPageAssignmentVideoPageModal = () => {
  const [selectedId, setSelectedId] = useQueryParam("assignmentId", undefined);

  const videoPageModalInitialObject = useMemo(() => {
    if (selectedId) return { superPageAssignmentId: parseInt(selectedId) };
    return undefined;
  }, [selectedId]);

  const onAssignmentClick = useCallback(
    (assignmentId: number) => setSelectedId(assignmentId.toString()),
    [setSelectedId]
  );

  const modal = (
    <VideoPageModal
      open={!!videoPageModalInitialObject}
      initialObject={videoPageModalInitialObject}
      onClose={() => setSelectedId(undefined)}
    />
  );

  return { modal, onAssignmentClick };
};
